import { render, staticRenderFns } from "./StatsChartPanel.vue?vue&type=template&id=2bd6485e&"
import script from "./StatsChartPanel.vue?vue&type=script&lang=js&"
export * from "./StatsChartPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports